import { ApiError } from '@/errors/apiError';
import { BaseError } from '@/errors/baseError';
import { AxiosError } from 'axios';

export const normalizeError = (error: unknown) => {
    if (error instanceof AxiosError) {
      return new ApiError(error.response?.status ?? 500, error.message, error);
    }
    if (error instanceof ApiError) {
      return error;
    }
    if (error instanceof BaseError) {
        return error;
    }
    if (error instanceof Error) {
        return new BaseError(error.message, error);
    }
    return new BaseError('An unknown error occurred', error);
};
